// removed by extract-text-webpack-plugin
module.exports = {"manager":"src-byos-component----Manager-module---manager---1pNH4","top":"src-byos-component----Manager-module---top---1VQoS","bottom":"src-byos-component----Manager-module---bottom---1gALR","description":"src-byos-component----Manager-module---description---3JN2v","descriptionFirst":"src-byos-component----Manager-module---descriptionFirst---D9UaD src-byos-component----Manager-module---description---3JN2v","editor":"src-byos-component----Manager-module---editor---1XgJy","footer":"src-byos-component----Manager-module---footer---1iMQO"};


//////////////////
// WEBPACK FOOTER
// ./src/byos/component/Manager.module.css
// module id = 621
// module chunks = 198924488578035